import { render } from "./DashboardBoxShow.vue?vue&type=template&id=5191fb64&scoped=true"
import script from "./DashboardBoxShow.vue?vue&type=script&lang=js"
export * from "./DashboardBoxShow.vue?vue&type=script&lang=js"

import "./DashboardBoxShow.vue?vue&type=style&index=0&id=5191fb64&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5191fb64"]])

export default __exports__